import type {ISketchObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {MultiTargetRelation} from '../MultiTargetRelation';

let count = 0;

/**
 * 判断对象是否为点在线段中点关系。
 * @param value 待判断对象。
 * @returns 是否为中点关系。
 */
export function isPointMidpointConstraint(value: object): value is PointMidpointConstraint {
    return Reflect.get(value, 'isPointMidpointConstraint') === true;
}

/**
 * 点在线段中点关系定义。
 *
 * 目标组合由公式编译器校验为“一个点 + 一条直线”，本类不直接移动点。
 */
export class PointMidpointConstraint extends MultiTargetRelation<ISketchObject> {
    /** 运行时类型标记。 */
    public readonly isPointMidpointConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Midpoint;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '中点';
    }
}
